import { useMemo } from "react";
import query from "../url/query";
import useCurrentPath from "./useCurrentPath";

/**
 * Parses query from the url
 *
 * @type {(url: string) => { [paramName: string]: string }}
 */
export function useParsedQuery(url) {
	return useMemo(
		() => query(url), // factory
		[url],
	);
}

/**
 * Returns query from current url
 *
 * @type {() => { [paramName: string]: string }}
 */
function useQueryString() {
	const asPath = useCurrentPath();

	return useParsedQuery(asPath);
}

export default useQueryString;
